import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs';
import { CommonModule } from '@angular/common';
import { EqValidator } from '../../interfaces';
import { EqFormService } from '../eqform.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
const Material = [
  MatInputModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
  MatAutocompleteModule
];
@Component({
  selector: 'eq-search',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() options: any;
  controlName: any;
  @Input() label: string = 'Sample';
  @Input() header: string = '';
  @Input() appearance: any = 'outline';
  @Input() name: string = '';
  @Input() icon: string = '';
  // should be passed form parent component as input
  @Input() form: any;
  @Input() validators: EqValidator[] = [];
  @Output() onChange = new EventEmitter<any>();

  apiEndPoints = 'asset';
  constructor(private formService: EqFormService) {}
  ngOnInit(): void {
    if (!this.form || !this.name) {
      const errMsg: string = !this.form
        ? 'form attribute is missing.'
        : 'name attribute is missing.';
      throw Error(errMsg);
    }
    this.formService.addFormControl(this.form, this.name, this.validators);
    this.controlName = this.form.controls[this.name];
    this.options = this.controlName?.valueChanges?.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((value) => {
        const query = {
          name: value
        };
        return this.formService.search(query).pipe(
          map((resp: any) => {
            return resp;
          })
        );
      })
    );
  }
  ngOnDestroy(): void {
    this.form.removeControl(this.name);
  }
  onSelect(value:any){
    this.onChange.emit(value)
  }
  displayFn(user: any): string {
    return user && user.name ? user.name : '';
  }
  getErrorMessage() {
    return this.formService.getErrorMessage(
      this.form,
      this.name,
      this.validators
    );
  }
  hasError() {
    return this.formService.hasError(this.form, this.name);
  }
  isValid(){
    return this.formService.isValid(this.form, this.name);
  }
}
